import React, { Component, Suspense } from "react";
import { withTranslation } from "react-multi-lang";
import { withAlert } from "react-alert";
import Service from "./../administrator/general/Service.jsx";
import store from "./../../redux_store/store/index";
import { isMultitenant } from "./../../custom_functions/Constance";
import $ from "jquery";
// const Service = React.lazy(() => import ("./../../custom_modules/administrator/general/Service.jsx"));
const TextBox = React.lazy(() => import("./../../controls/TextBox.jsx"));
const Newpwdgenetration = React.lazy(() => import('./../user_management/modules/Newpwdgenetration.jsx'));

class AdministratorLogin extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            UserNameValidcls: "",
            PasswordValidcls: "",
            UserName: "",
            Password: "",
            SiteCode: 1,
            ServiceToUrl: "",
            ServiceMethodType: "POST",
            ServiceHeaderobject: {},
            ServcieonSuccess: undefined,
            ServcieonFailure: undefined,
            login: true,
            siteobj: "",
            Userobj: "",
            passwordstatus: "",
        }
        this.ELNurl = window.appUrl.ELN;
    }

    componentDidMount() {
        $.session.remove("TenantLoginUser");
        $.session.remove("TenantUser");
        $.session.remove("TenantToken");
        this._isMounted = true;

        this.setState({
            ServiceToUrl: "" + this.ELNurl + "/Login/LoadSite",
            ServiceMethodType: "GET",
            ServcieonSuccess: this.onLoadsiteSuccess.bind(this),
            ServcieonFailure: this.onLoadsiteFaliure.bind(this),
            ServcieProcessbar: true,
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onLoadsiteFaliure(response) {

    }

    onLoadsiteSuccess(response) {
        this.setState({
            siteobj: response[0]
        });

    }

    UNSAFE_componentWillReceiveProps(nextProps) {
    }

    onUsernamechange = (value) => {
        this.setState({
            UserName: value
        })

    }

    onUserPasswordchange = (value) => {
        this.setState({
            Password: value
        })
    }

    onLoginClick = (e) => {
        if (this.state.UserName.includes(" ") || this.state.Password.includes(" ")) {
            this.props.alert.error(this.props.t("Master_Usersteam.IDS_EMPTYSPACE", {
                param: "",
            }));
        }
        else if (this.state.UserName.trim() !== "" &&
            this.state.Password.trim() !== ""
        ) {

            $.session.remove("TenantToken");

            let passObject = {
                username: this.state.UserName + "[" + this.state.SiteCode + "]",
                password: this.state.Password
            };
            this.setState({
                ServiceToUrl: "" + this.ELNurl + "/authenticate",
                ServiceHeaderobject: passObject,
                ServiceMethodType: "POST",
                ServcieonSuccess: this.onJWTAuthSuccess.bind(this),
                ServcieonFailure: this.onJWTAuthFailure.bind(this),
                ServcieProcessbar: false,
            });



            // } else {
            //     this.props.alert.error(this.props.t("LoginView.ID_NOTEXIST", {
            //         param: "",
            //     }));
            // }
        } else if (this.state.UserName.trim() === "" && this.state.Password.trim() === "") {
            this.props.alert.error(this.props.t("Login.IDS_MSG_ENTERVALIDUSERNAME", {
                param: "",
            }));
        } else if (this.state.UserName.trim() === "") {
            this.props.alert.error(this.props.t("Login.IDS_MSG_ENTERVALIDUSERNAME", {
                param: "",
            }));
        }
        else if (this.state.Password.trim() === "") {
            this.props.alert.error(this.props.t("Login.IDS_MSG_ENTERVALIDPASSWORD", {
                param: "",
            }));
        }
        // $.session.set("Administratoruser", "Administrator");
        // this.props.history.push("/administratorpage");
    }

    onJWTAuthSuccess(response) {

        let token = "Bearer " + response.token;

        $.session.set("TenantToken", token);
        let passobj = {
            sUsername: this.state.UserName,
            sPassword: this.state.Password,
            sSiteCode: this.state.SiteCode
        }

        this.setState({
            ServiceToUrl: "" + this.ELNurl + "/multitenant/login",
            ServiceHeaderobject: passobj,
            ServiceMethodType: "POST",
            ServcieonSuccess: this.onsendemailSuccess.bind(this),
            ServcieonFailure: this.onsendemailFailure.bind(this),
            ServcieProcessbar: false,
        });


        // request
        //     .post("" + this.ELNurl + "/multitenant/tenantadministratorlogin")
        //     .send(passobj)
        //     .set({ 'Authorization': $.session.get("Token"), 'X-TenantID': "MAIN", Accept: 'application/json' })
        //     .then((res) => {
        //         this.onsendemailSuccess(JSON.parse(res.text));
        //     }).catch((error) => {
        //         this.onsendemailFailure(error);
        //     });
    }
    onJWTAuthFailure(response) {

    }
    onsendemailSuccess(response) {
        let loggeduser = response.user;
        if (loggeduser.objResponse.status) {
            $.session.set("TenantLoginUser", loggeduser.username);
            $.session.set("TenantUser", loggeduser.usercode);
            $.session.set("lssitemaster", loggeduser.lssitemaster);
            store.getState().Loggeduser = loggeduser;

            if (isMultitenant === 1) {
                setTimeout(() => {
                    this.props.history.push("/ad_organisation");
                }, 100);
            }
            else {
                setTimeout(() => {
                    this.props.history.push("/ad_adhelpdocument");
                }, 100);
            }

        }
        else if (response.user.objResponse.information === "ID_INVALID") {

            this.props.alert.error(this.props.t("Header.IDS_MSG_INVALID", { param: "", }));
        }
        else if (response.user.objResponse.information === "IDS_MSG_LOCKED") {

            this.props.alert.error(this.props.t("Login.IDS_MSG_LOCKED", { param: "", }));
        }
        else {
            this.props.alert.error(this.props.t("Header.IDS_MSG_INVALID", {
                param: "",
            }));
        }

    }

    onsendemailFailure(response) {

    }

    onuserNameFocusout() {
        this.validateExistingUser();
    }

    validateExistingUser() {


        let validation = true;
        this.setState({ InvalidUserTest: "" });
        if (this.state.UserName !== undefined && this.state.UserName.trim() === "" && this.state.Password !== undefined && this.state.Password.trim() === "") {
            this.setState({ UserNameValidcls: "invalid", PasswordValidcls: "invalid" });
            validation = false;
        } else {
            let objdat = {};
            objdat["sUsername"] = this.state.UserName;
            objdat["sSiteCode"] = this.state.SiteCode;
            objdat["objsilentaudit"] = { transactiondate: new Date() };

            this.setState({
                UserNameValidcls: "",
                PasswordValidcls: "",
                ServiceToUrl: "" + this.ELNurl + "/Login/CheckUserAndPassword",
                ServiceHeaderobject: objdat,
                ServiceMethodType: "POST",
                ServcieonSuccess: this.onCheckuserSuccess.bind(this),
                ServcieonFailure: this.onCheckuserFailure.bind(this),
                ServcieProcessbar: false,
                ServiceTenant: "MAIN"
            });

        }
        return validation;
    }



    onCheckuserSuccess(response) {
        let site = parseInt(this.state.SiteCode);
        if (response[0].objResponse.information === "Invalid user") {

            this.props.alert.error(this.props.t("Login.IDS_MSG_NOTEXIST", { param: "", }));
            // this.setState({
            //   InvalidUserTest: response.objResponse.information,
            // });
        } else if (response[0].objResponse.information === "GenerateNewPassword") {
            if (response[0].lssitemaster.sitecode !== site) {

                this.props.alert.error(this.props.t("Login.IDS_MSG_SITEVALID", { param: "", }));
            } else {
                this.setState({
                    // CurrentView: 1,
                    login: false,
                    SiteCode: this.state.SiteCode,
                    UserName: this.state.UserName,
                    passwordstatus: response[0].passwordstatus,
                    // siteobj: response.user.lssitemaster
                    Userobj: response[0],
                });
                // this.props.onforgot(this.state.SiteCode, this.state.UserName, response.lssitemaster, response);
                this.setState({
                    login: false
                })
            }
        } else if (
            response[0].objResponse.information === "Valid user and password exist"
        ) {
            this.setState({
                // viewchart: true,
                UserID: response[0].usercode,
            });
        }
    }

    onCheckuserFailure(response) { }

    Cancel(usernameval) {
        this.setState({
            login: true
        })
            ;
    }


    onContentKeyPress(e) {
        if (e.key === "Enter") {

            this.onLoginClick(e);
        }

    }

    render() {

        return (

            <div className="login-form adminLoginContainer"
                onKeyPress={this.onContentKeyPress.bind(this)}>
                <div>

                    <Service
                        Tourl={this.state.ServiceToUrl}
                        MethodType={this.state.ServiceMethodType}
                        onSuccess={this.state.ServcieonSuccess}
                        onFailure={this.state.ServcieonFailure}
                        Headerobject={this.state.ServiceHeaderobject}
                        onReseturl={() => {
                            this.setState({ ServiceToUrl: "" });
                        }}
                    />


                    <div className="container-fluid">
                        <div className="row align-items-center vh-100 justify-content-center">
                            <div className="col-md-4 adminLoginBox">
                                <div className="card shadow-sm">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-center m-4">
                                            <div className="eln-logo mb-4">
                                                <img src="./images/Logilab_ELN_Logo.svg" alt="eln-logo" />
                                                <span class="version-txt">Admin</span>
                                            </div>
                                        </div>

                                        {this.state.login === true ? (
                                            <div>
                                                <div className="form-group">

                                                    <label htmlFor="inputText" className="form-label">
                                                        {this.props.t("Login.IDS_LBL_USERNAME", { param: "" })}
                                                    </label>
                                                    <Suspense fallback={<div></div>}>
                                                        <TextBox
                                                            txtType="text"
                                                            txtClsname={
                                                                "form-control form-control-sm " + this.state.UserNameValidcls
                                                            }
                                                            txtName="Username"
                                                            txtid="idUsername"
                                                            txtDataType="Text"
                                                            txtmaxlength="100"
                                                            txtvalue={this.state.UserName}
                                                            sendData={this.onUsernamechange.bind(this)}
                                                            ontxtfocusOut={this.onuserNameFocusout.bind(this)}
                                                            txtrequired="true"
                                                            autofocus="true"
                                                        />
                                                    </Suspense>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="inputPassword" className="form-label">
                                                        {this.props.t("Login.IDS_LBL_PASSWORD", { param: "" })}
                                                    </label>
                                                    <Suspense fallback={<div></div>}>
                                                        <TextBox
                                                            txtType="password"
                                                            txtClsname={
                                                                "form-control form-control-sm " + this.state.PasswordValidcls
                                                            }
                                                            txtName="Password"
                                                            txtid="idPassword"
                                                            txtDataType="Text"
                                                            txtmaxlength="100"
                                                            txtvalue={this.state.Password}
                                                            sendData={this.onUserPasswordchange.bind(this)}
                                                            ref="txtPassword"
                                                            txtrequired="true"
                                                            autofocus="false"
                                                        />
                                                    </Suspense>
                                                </div>
                                                <div className="form-group">
                                                    <input
                                                        type="button"
                                                        id="inputText"
                                                        className="btn btn-user btn-primary-blue"
                                                        value={this.props.t("Login.IDS_LBL_LOGIN", { param: "" })}
                                                        onClick={this.onLoginClick.bind(this)}
                                                    />
                                                </div>

                                            </div>) : (
                                            <div>
                                                <Suspense fallback={<div></div>}>
                                                    <Newpwdgenetration
                                                        oncancel={this.Cancel.bind(this)}
                                                        Userobj={this.state.Userobj}
                                                        sitecode={this.state.SiteCode}
                                                        username={this.state.UserName}
                                                        siteobj={this.state.siteobj}
                                                        passwordstatus={this.state.passwordstatus}
                                                    />
                                                </Suspense>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            // {/* </form> */ }
        );
    }
}
export default withAlert()(withTranslation(AdministratorLogin));